var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coberturas"},[_c('h4',[_vm._v(" Coberturas ")]),_c('b-table',{attrs:{"fields":_vm.fields,"items":_vm.items},scopedSlots:_vm._u([{key:"cell(indemnizacion)",fn:function(data){return [_c('span',{class:_vm.getColor(data.item)},[_vm._v(" "+_vm._s(data.item.indemnizacion)+" ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }